import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const Nav = () => {
  const navigate = useNavigate();

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-syne font-extrabold text-lg tracking-tightest select-none"
        >
          HANCOCK<span className="text-white/40">.</span>
        </a>

        <nav className="hidden md:flex items-center gap-10 text-xs uppercase tracking-[0.2em] text-white/50">
          <a href="#about" className="hover:text-white transition-colors duration-300" data-testid="nav-about">About</a>
          <a href="#method" className="hover:text-white transition-colors duration-300" data-testid="nav-method">The Method</a>
          <a href="#deliverables" className="hover:text-white transition-colors duration-300" data-testid="nav-deliverables">What To Expect</a>
          <a href="#for-who" className="hover:text-white transition-colors duration-300" data-testid="nav-forwho">The Fit</a>
        </nav>

        <button
          onClick={() => navigate("/apply")}
          data-testid="nav-apply-btn"
          className="group relative overflow-hidden rounded-full border border-white/20 px-6 py-2.5 text-xs uppercase tracking-[0.18em]"
        >
          <span className="relative z-10 transition-colors duration-300 group-hover:text-black">Apply Now</span>
          <span className="absolute inset-0 -z-0 translate-y-full bg-white transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0" />
        </button>
      </div>
    </motion.header>
  );
};
